<lc-offline-indicator />

<lc-socket-status />
<router-outlet />
<!-- <div
    *ngIf="screenProtectionService.showProtectionOverlay()"
    class="fixed inset-0 z-[99999] bg-black/95 backdrop-blur-xl select-none"
    aria-live="assertive"
    aria-label="Proteção de tela ativa"
></div> -->
<lc-modal-confirmation
    *ngIf="modalOptions"
    [header]="modalOptions.header"
    [body]="modalOptions.body"
    (confirm)="onModalConfirm()"
    (cancel)="onModalCancel()"
></lc-modal-confirmation>
<lc-confirmation-feedback
    *ngIf="feedbackOptions"
    [message]="feedbackOptions.message"
    [visible]="true"
    (closed)="onFeedbackClosed()"
></lc-confirmation-feedback>

<!-- Termo de uso de localização. Fica na raiz para aparecer sobre qualquer
     tela; o próprio componente controla sua visibilidade. -->
<lc-location-disclosure />
